import styled from "styled-components";

export const PeakCartonCountContainer = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 1em 1.5em;
`;

export const VolumeGridWrapper = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const VolumeGridRow = styled("div")`
  display: flex;
  flex-direction: row;
`;

export const TableWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  &:last-child {
    border-bottom: none;
  }
`;

export const TableRow = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
  & .headercell {
    background-color: #e0e0e0;
    color: black;
    font-weight: bold;
  }
`;

export const TableCell = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0.5em;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  &:last-of-type: {
    borde: none;
  }
`;

export const RecruitmentPlanMainTableContainer = styled.div`
  display: flex;
  flex: 1;
  flexdirection: row;
  min-height: 40vh;
  max-height: 40vh;
`;

export const VerticalHeaderText = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.1em;
`;
export const VerticalHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 15em;
  background-color: #e3f2fd;
  overflow-x: scroll;
  & > :nth-child(3) {
    background: #2196f377;
  }
`;

export const ScrollableHorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  max-width: calc(100vw - 15em);
  overflow-x: auto;
`;

export const PickPlanEntryColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 15em;
  background-color: "#ECEFF1";
  height: "100%";
  border-right: 1px solid #64b5f6;
`;

export const DateContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1em;
  background-color: #e3f2fd;
`;

export const DaySectionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  background-color: #e8eaf6;
`;

export const DaySectionText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-weight: bolder;
  font-size: 1em;
`;

export const FigureMainContainer = styled.div`
  display: flex;
  flex: 6;
  flex-direction: column;
`;

export const FigureRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  &:nth-child(2n) {
    background: #eee;
  }

  &:first-child {
    background: #2196f377;
  }
`;

export const PickPlanFigures = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-size: 1.1em;
  ${(props) =>
    props.highlighted &&
    `
    color: red;
    font-weight: bold;
  `};
  ${(props) =>
    props.bolded &&
    `
    font-weight: bold;
  `};
`;
